export const getCurrencyApi = () => `/console/currency/`;

export const getReconcileInvoiceApi = (params, query) => {
    const queryString = new URLSearchParams(query).toString();
    return `lease/${params?.leaseSlug}/invoices/reconcile-batches/${queryString ? `?${queryString}` : ""}`;
};

//  Add Endpoint
export const addReconcileBatchApi = (params, payload) => {
    return `/lease/${params?.leaseSlug}/invoices/reconcile-batches/`;
}

//  Edit Endpoint
export const editReconcileBatchApi = (params) => {
    return `/lease/${params?.leaseSlug}/invoices/reconcile-batches/${params?.slug}`;
}

//  Delete Endpoint
export const deleteReconcileBatchApi = (params) => {
    return `/lease/${params?.leaseSlug}/invoices/reconcile-batches/`;
}

export const getReconcileInvoiceInitApi = (params) => {
    return `/invoice/reconcile_init/${params?.slug}`;
}

//  Unlink reconcile invoice
export const unLinkReconcileInvoiceApi = (params) => {
    return `/invoice/reconcile/${params?.reconcile_slug}/link_unlink?action=unlink&invoice_ids=${params?.unlink_id}`;
}

//  link reconcile invoice
export const linkReconcileInvoiceApi = (params) => {
    return `/invoice/reconcile/${params?.reconcile_slug}/link_unlink?action=link&invoice_ids=${params?.unlink_id}`;
}